import React, { useEffect, useState } from 'react'
import { mainApi } from '../../../store/services/mainApi'
import { useNavigate, useParams } from 'react-router'
import ModalUI from '../ModalUI/ModalUI'
import './FastTempleOrder.scss'
import { Box, Button, CircularProgress, TextField, Modal, Checkbox } from '@mui/material'
import useUpdatePrice from '../../../hooks/useUpdatePrice'
import SearchItem from './SearchItem/SearchItem'
import useReplaceAccent from '../../../hooks/replaceAccent'
import SearchListItem from './SearchItem/SearchListItem/SearchListItem'
import useSendLog from '../../../hooks/useSendLog'
import { useDispatch, useSelector } from 'react-redux'
import FTOOrderModal from './FTOOrdersModal/FTOOrderModal'
import { setItemsTemplate } from '../../../store/slices/templateOrder'
import { setItemsCart } from '../../../store/slices/allItemsCart'

const FastTempleOrder = ({ tradeNameProp = '', filterOrder, sxBtn = {}, textBtn = 'Click Me', sx={} }) => {
  const { data: allProductsData, isLoading: isAllProductsLoading } = mainApi.useFindAllWordsQuery({
    pollingInterval: 50000,
  })

  function getQueryParamValue(param) {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get(param) === 'true'
  }

  const [isOpenModal, setIsOpenModal] = useState(getQueryParamValue('cloneModal') || false)
  const tradeNameParams = tradeNameProp !== '' ? tradeNameProp : useParams().tradeName

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [searchModal, setSearchModal] = useState(false)
  const [cloneOrder, setCloneOrder] = useState({})
  const [editedItems, setEditedItems] = useState([])

  useEffect(() => {
    setEditedItems(cloneOrder?.items ? [...cloneOrder.items] : [])
  }, [cloneOrder])


  useEffect(() => {
    if (cloneOrder && cloneOrder?.items) {
      const updatePriceList = useUpdatePrice(cloneOrder?.items ? [...cloneOrder.items] : [], allProductsData, isAllProductsLoading)
      setEditedItems(updatePriceList)
      dispatch(setItemsTemplate(updatePriceList))

      console.log(cloneOrder?.items)
    }
  }, [cloneOrder])

  
  const [searchWord, setSearchWord] = useState('')
  const [searchData, setSearchData] = useState([])


  useEffect(() => {
    if (!isAllProductsLoading) {
      const withAccetWord = useReplaceAccent(searchWord?.toLocaleLowerCase())
      // setSearchData();
      const searchList = allProductsData?.filter((el) => useReplaceAccent(String(el?.name ?? '').toLocaleLowerCase()).includes(withAccetWord));
      setSearchData(searchList);
    }
  }, [searchWord, isAllProductsLoading])


  const isSalePage = location.pathname.includes('/group')
  const platformParam = useParams().platform

  const handleSendOrder = async (items) => {
    console.log(items)
    let cart = items
    ?.filter((el) => !(el.sku == 'BroGhoaCilCitmac30/40gr' || el.sku == 'BLEMEkg'))
    ?.filter((el) => !(el.sku?.slice(0,3)?.includes('MCH')))
    ?.filter((el) => el.sku !== 'BBroCILtar100')?.map((el) => ({...el, status: {}}))

    dispatch(setItemsCart(cart.map((el) => {
          return { ...el }
        })?.filter((el) => el.sku !== 'BBroCILtar100')))
    if (!isSalePage) {
      if (tradeNameParams !== undefined) {
        if (platformParam !== undefined) {
          navigate(`/newOrder/${platformParam}/${tradeNameParams}`)
        } else {
          navigate(`/newOrder/${tradeNameParams}`)
        }
        window.scrollTo(0, 0)
      } 
    } else {
      navigate('/group/newOrder')
    }    
  }

  const handleClickRepetirPedido = useSendLog('Click on Repetir pedido', {})

  return (
    <div style={{...sx?.container}}>
      <button
        style={sxBtn}
        onClick={() => {
          setIsOpenModal(true)
          handleClickRepetirPedido()
        }}
      >
        {textBtn}
      </button>

      {isOpenModal && (
        <FTOOrderModal
          setIsOpenModal={setIsOpenModal}
          setCloneOrder={setCloneOrder}
          allProductsLoading={isAllProductsLoading}
          tradeNameParams={tradeNameParams}
          filterOrder={filterOrder}
          handleSendOrder={handleSendOrder}
        />
      )}
      {searchModal && (
        <ModalUI setIsOpenModal={() => setSearchModal(false)} sx={{ padding: '20px 10px' }}>
          <SearchItem searchWord={searchWord} setSearchWord={setSearchWord} sx={{ marginTop: '10px' }} />
          {searchData?.slice(0, 10)?.map((el, index) => (
            <SearchListItem item={el} key={el.sku + index} setEditedItems={setEditedItems} editedItems={editedItems} />
          ))}
        </ModalUI>
      )}
      
    </div>
  )
}

export default FastTempleOrder
